import $ from 'jquery';
import EditorJs from './editorJs';

export default class Social {
  init () {
    $(document).on('click', '.user-social-post-card__interaction-comment', event => {
      const self = $(event.currentTarget);
      const label = self.find('span:last-child');
      const orig = label.text();
      const container = self.parents('.user-social-post-card__social');
      const holder = container.find('.user-social-post-card__comments');

      if (!label.data('orig')) {
        label.data('orig', orig);
      }

      if (!container.data('init')) {
        const post_id = container.find('input[name="comment_post_ID"]').val();
        new EditorJs().init(`#post-comment-${post_id}`);
        container.data('init', true);
      }

      if (holder.is(':visible')) {
        holder.fadeOut(300);
        label.text(label.data('orig'));
      } else {
        label.text('Stäng')
        holder.fadeIn(300);
      }
    });

    $(document).on('click', '.post-social__button--comment', event => {
      const self = $(event.currentTarget);
      const label = self.find('span:last-child');
      const orig = label.text();
      const container = self
        .parents('.post-social')
        .siblings('.post-social__comments');

      if (!label.data('orig')) {
        label.data('orig', orig);
      }

      if (!container.data('init')) {
        const post_id = container.find('input[name="comment_post_ID"]').val();
        new EditorJs().init(`#post-comment-${post_id}`);
        container.data('init', true);
      }

      if (container.is(':visible')) {
        container.fadeOut(300);
        label.text(label.data('orig'));
      } else {
        label.text('Stäng')
        container.fadeIn(300);
      }
    });
  }
}
